// extracted by mini-css-extract-plugin
export default {"book-list-wrapper":"BookList_book-list-wrapper__CFf+g","book-list":"BookList_book-list__thU-V"};